<template>
    <UikTabContainer>
        <UikTabItem
            v-for="(tab,key) in tabs"
            :key="key"
            :extra="typeof tab === 'object' ? tab.number.toString() : ''"
            :active="key == active"
            @click.native="$emit('change', key)"
        >
            {{ typeof tab !== 'object' ? tab : tab.name }}
        </UikTabItem>
    </UikTabContainer>
</template>

<script>
export default {
    name: "UikTabs",
    model: {
        prop: "active",
        event: "change"
    },
    props: {
        tabs: { type: Object, default: () => {}, required: true },
        active: { type: String, default: "" }
    }
}
</script>

<style lang="scss">

</style>
